/* Esteé Paris - productpagina "Ivoire" (variant 'test' van A/B-test pdp-ivoire, okt 2026).
   Werkt alleen als <html> de klasse ab-ivoire heeft. Geen vooraf gekozen maat; toevoegen via
   /cart/add.js zodat de fetch-hook in theme.liquid add_to_cart_v2 vuurt op de echte respons.
   De submit stopt bij het formulier, zodat de form-submit-hook geen ATC telt zonder maat. */
(function () {
  'use strict';
  if (!document.documentElement.classList.contains('ab-ivoire')) return;
  var root = document.querySelector('[data-ivo]');
  if (!root) return;
  var data = JSON.parse(root.querySelector('[data-ivo-json]').textContent);
  var T = data.t || {};
  var form = root.querySelector('[data-ivo-form]');
  var idInput = form.querySelector('[data-ivo-id]');
  var atc = form.querySelector('[data-ivo-atc]');
  var atcLabel = atc.querySelector('[data-ivo-atc-label]');
  var atcPrice = atc.querySelector('[data-ivo-atc-price]');
  var priceEl = root.querySelector('[data-ivo-price]');
  var wasEl = root.querySelector('[data-ivo-was]');
  var strip = root.querySelector('[data-ivo-strip]');
  var sticky = root.querySelector('[data-ivo-sticky]');
  var stickyBtn = root.querySelector('[data-ivo-sticky-btn]');
  var stickySub = root.querySelector('[data-ivo-sticky-sub]');
  var stickyPrice = root.querySelector('[data-ivo-sticky-price]');
  var sizeName = data.sizeIndex >= 0 ? data.options[data.sizeIndex] : null;
  var added = false;

  var selected = {};
  data.options.forEach(function (o, i) {
    var vals = [];
    data.variants.forEach(function (v) { if (vals.indexOf(v.options[i]) < 0) vals.push(v.options[i]); });
    if (vals.length === 1) selected[o] = vals[0];
    else if (i !== data.sizeIndex) selected[o] = data.initial[i];
    else selected[o] = null;
  });

  function money(c) {
    try { return new Intl.NumberFormat(data.locale || 'fr', { style: 'currency', currency: data.currency || 'EUR' }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function exact() {
    return data.variants.filter(function (v) {
      return data.options.every(function (o, i) { return v.options[i] === selected[o]; });
    })[0] || null;
  }
  function closest() {
    return data.variants.filter(function (v) {
      return data.options.every(function (o, i) { return !selected[o] || v.options[i] === selected[o]; });
    })[0] || data.variants[0];
  }
  function missing() { return data.options.filter(function (o) { return !selected[o]; }); }
  function lineFor(name) {
    var out = null;
    root.querySelectorAll('[data-ivo-line]').forEach(function (l) { if (l.getAttribute('data-ivo-line') === name) out = l; });
    return out;
  }

  function paint() {
    root.querySelectorAll('[data-ivo-option]').forEach(function (b) {
      var on = selected[b.getAttribute('data-ivo-option')] === b.getAttribute('data-ivo-val');
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-ivo-value]').forEach(function (el) {
      var v = selected[el.getAttribute('data-ivo-value')];
      el.textContent = v || el.getAttribute('data-placeholder');
      el.classList.toggle('is-empty', !v);
    });
    var v = exact();
    var shown = v || closest();
    if (v) idInput.value = v.id;
    priceEl.textContent = money(shown.price);
    atcPrice.textContent = '· ' + money(shown.price);
    if (stickyPrice) stickyPrice.textContent = money(shown.price);
    if (shown.compare_at_price && shown.compare_at_price > shown.price) {
      wasEl.textContent = money(shown.compare_at_price);
      wasEl.hidden = false;
    } else {
      wasEl.hidden = true;
    }
    var parts = [];
    data.options.forEach(function (o, i) { if (selected[o] && i !== data.sizeIndex) parts.push(selected[o]); });
    if (sizeName) parts.push(sizeName + ' ' + (selected[sizeName] || T.choose));
    if (stickySub) stickySub.textContent = parts.join(' · ');
    var soldOut = v && !v.available;
    atc.disabled = !!soldOut;
    atcLabel.textContent = added ? T.added : (missing().length ? T.need : T.atc);
    atcPrice.hidden = added || missing().length > 0;
    if (stickyBtn) stickyBtn.textContent = added ? T.stickyAdded : (missing().length ? T.stickyNeed : T.stickyAdd);
  }

  function hint(name) {
    var line = lineFor(name);
    if (!line) return;
    var h = line.querySelector('[data-ivo-hint]');
    line.classList.add('is-missing');
    if (h) h.textContent = T.hint;
    var r = line.getBoundingClientRect();
    if (r.top < 80 || r.bottom > window.innerHeight - 100) line.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var first = line.querySelector('[data-ivo-option]:not([disabled])');
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
  }
  function clearHint(name) {
    var line = lineFor(name);
    if (!line) return;
    line.classList.remove('is-missing');
    var h = line.querySelector('[data-ivo-hint]');
    if (h) h.textContent = '';
  }

  /* --- galerij --- */
  function goToImage(imgId) {
    if (!strip || !imgId) return;
    var slides = strip.querySelectorAll('.ivo-slide');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('data-img-id') === String(imgId)) {
        if (window.matchMedia('(min-width: 900px)').matches) slides[i].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        else strip.scrollTo({ left: slides[i].offsetLeft - strip.offsetLeft - 16, behavior: 'smooth' });
        return;
      }
    }
  }

  function select(name, val, btn) {
    selected[name] = val;
    added = false;
    if (btn && btn.hasAttribute('data-img-id')) goToImage(btn.getAttribute('data-img-id'));
    else if (name !== sizeName) { var v = exact(); if (v && v.image_id) goToImage(v.image_id); }
    clearHint(name);
    paint();
    try { if (window.posthog && window.posthog.capture) window.posthog.capture('variant_selected', { option: name, value: val, ui: 'ivoire' }); } catch (e) {}
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ivo-option]');
    if (!b || b.disabled) return;
    select(b.getAttribute('data-ivo-option'), b.getAttribute('data-ivo-val'), b);
  });

  /* --- maat-quiz (paneel van de controlesectie): aanbeveling hier toepassen --- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-ep-quiz-apply]') || !sizeName) return;
    var quiz = document.querySelector('[data-ep-quiz]');
    var rec = quiz && quiz.dataset.recommendation;
    if (!rec) return;
    var ALIAS = { XXL: '2XL', '2XL': 'XXL', XXXL: '3XL', '3XL': 'XXXL', XXXXL: '4XL', '4XL': 'XXXXL' };
    var want = [rec, ALIAS[rec]];
    var hit = null;
    root.querySelectorAll('[data-ivo-option]').forEach(function (b) {
      if (!hit && b.getAttribute('data-ivo-option') === sizeName && want.indexOf(b.getAttribute('data-ivo-val')) > -1 && !b.disabled) hit = b;
    });
    if (hit) select(sizeName, hit.getAttribute('data-ivo-val'), hit);
  }, true);

  /* --- toevoegen aan het mandje --- */
  function add() {
    var m = missing();
    if (m.length) { hint(m[0]); return; }
    var v = exact();
    if (!v || !v.available) return;
    atc.disabled = true;
    atcLabel.textContent = T.adding;
    atcPrice.hidden = true;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(base + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('add');
        return fetch(base + 'cart.js', { cache: 'no-store' });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        added = true;
        atc.disabled = false;
        paint();
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { response: cart, trigger: atc }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart }, bubbles: true }));
      })
      .catch(function () {
        atc.disabled = false;
        paint();
        var line = lineFor(sizeName) || root;
        var h = line.querySelector('[data-ivo-hint]');
        if (h) h.textContent = T.error;
      });
  }
  /* Knop is type=button (fix 08-10): de form-submit-hook in theme.liquid luistert in de capture-fase en telde
     anders elke klik zonder maat als add_to_cart_v2. Nu telt alleen de fetch-hook, op de echte /cart/add-respons. */
  atc.addEventListener('click', add);
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    e.stopPropagation();
    add();
  });

  /* --- vaste koopbalk: zichtbaar zolang de hoofdknop uit beeld is en het mandje dicht --- */
  if (sticky && 'IntersectionObserver' in window) {
    var atcVisible = true, cartOpen = false;
    var update = function () {
      var show = !atcVisible && !cartOpen;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      stickyBtn.tabIndex = show ? 0 : -1;
    };
    new IntersectionObserver(function (entries) { atcVisible = entries[0].isIntersecting; update(); }, { threshold: 0 }).observe(atc);
    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      new MutationObserver(function () { cartOpen = drawer.classList.contains('drawer--is-open'); update(); })
        .observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    stickyBtn.addEventListener('click', add);
  }

  /* --- start: gekozen kleur in beeld (bij ?variant=) --- */
  paint();
  var start = closest();
  if (start && start.image_id && !window.matchMedia('(min-width: 900px)').matches) {
    var first = strip && strip.querySelector('.ivo-slide');
    if (first && first.getAttribute('data-img-id') !== String(start.image_id)) setTimeout(function () { goToImage(start.image_id); }, 300);
  }
})();
